import React from 'react'
import { FaArrowLeft } from 'react-icons/fa'
import { useLocation, useNavigate } from 'react-router-dom'
import CustomTabs from '../../../shared/CustomTabs'
import CustomButton from '../../../shared/CustomButton'

// Import tab components
import TimelineTab from '../../../components/his/patient-profiling/TimelineTab'
import InsuranceTab from '../../../components/his/patient-profiling/InsuranceTab'
import NotesTab from '../../../components/his/patient-profiling/NotesTab'
import AdmissionTab from '../../../components/his/patient-profiling/AdmissionTab'
import MonitoringTab from '../../../components/his/patient-profiling/MonitoringTab'
import MedicationTab from '../../../components/his/patient-profiling/MedicationTab'
import FormsTab from '../../../components/his/patient-profiling/FormsTab'
import FilesTab from '../../../components/his/patient-profiling/FilesTab'
import PrescriptionTab from '../../../components/his/patient-profiling/PrescriptionTab'
import BillsTab from '../../../components/his/patient-profiling/BillsTab'
import LabsImagingTab from '../../../components/his/patient-profiling/LabsImagingTab'
import TasksTab from '../../../components/his/patient-profiling/TasksTab'
import PatientHistoryTab from '../../../components/his/patient-profiling/PatientHistoryTab'
import GeneralTab from '../../../components/his/patient-profiling/GeneralTab'
import TransferTab from '../../../components/his/patient-profiling/TransferTab'
import DischargeTab from '../../../components/his/patient-profiling/DischargeTab'
import { useSelector } from 'react-redux'
import NewFormsTab from '../../../components/his/patient-profiling/NewFormsTab'
import{ useTranslation } from 'react-i18next'
function InPatientMain () {
  const navigate = useNavigate()
  const { state } = useLocation()
  const patient = useSelector(state => state?.beneficiary?.seletedPatientData)
  const activeTabIndex = state?.activeTabIndex || 0
const { t } = useTranslation()
  const handleBackClick = () => {
    navigate(-1) // Go back to previous page
  }

  const patientTabs = [
    {
      name: t('Timeline'),
      content: <TimelineTab patient={patient} />
    },
    // {
    //   name: 'Insurance',
    //   content: <InsuranceTab patient={patient} />
    // },
    {
      name: t('Notes'),
      content: <NotesTab patient={patient} />
    },
    // {
    //   name: 'Admission',
    //   content: <AdmissionTab patient={patient} />
    // },
    {
      name: t('Monitoring'),
      content: <MonitoringTab patient={patient} />
    },
    {
      name: t('Medication'),
      content: <MedicationTab patient={patient} />
    },
    {
      name: t('Forms'),
      content: <NewFormsTab patient={patient} />
    },
    {
      name: t('Files'),
      content: <FilesTab patient={patient} />
    },
    {
      name: t('Prescription'),
      content: <PrescriptionTab patient={patient} />
    },
    {
      name: t('Bills'),
      content: <BillsTab patient={patient} />
    },
    {
      name: t('Labs & Imaging'),
      content: <LabsImagingTab patient={patient} />
    },
    {
      name: t('Tasks'),
      content: <TasksTab patient={patient} />
    },
    // {
    //   name: 'Patient History',
    //   content: <PatientHistoryTab patient={patient} />
    // },
    // {
    //   name: 'General',
    //   content: <GeneralTab patient={patient} />
    // },
    {
      name: t('Transfer'),
      content: <TransferTab patient={patient} />
    },
    {
      name: t('Discharge'),
      content: <DischargeTab patient={patient} />
    }
  ]

  return (
    <div className='flex flex-col h-full bg-white'>
      {/* Header */}
      <div className='p-4 border-b border-gray-200 bg-gray-50'>
        <div className='flex items-center gap-4'>
          <CustomButton
            icon={<FaArrowLeft size={16} />}
            buttonType='secondary'
            onClick={handleBackClick}
            label={t('Back to Ward')}
          />
        </div>
      </div>

      {/* Patient Information Tabs */}
      <div className='flex-1 overflow-hidden'>
        <CustomTabs
          tabs={patientTabs}
          activeTabIndex={activeTabIndex}
          className='h-full'
          tabClassName='text-sm'
          panelClassName='h-full'
        />
      </div>
    </div>
  )
}

export default InPatientMain
